import {deleteTemplateCerificateApi, deleteCerificateApi , deleteShareCerificateApi} from '@/api/certificate'
export const DeleteMixin = {
  data () {
    return {
      selected_deleteing_id:[],
      selected_cer_deleteing_id:[],
      selected_share_deleteing_id:[],
      delete_share_id:[],
      delete_id:[],
      deleted_cer_id:[],
      activeConfirm:false
    }
  },
  methods:{
    openConfirmshared (id, type) {
      if (type === 'single') {
        this.selected_share_deleteing_id[0] = id
      }
      this.delete_share_id.length = 0
      this.delete_share_id[0] = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this record ?',
        accept: this.acceptAlertShare
      })
      
    },
    openConfirm (id, type) {
      if (type === 'single') {
        this.selected_deleteing_id[0] = id
      }
      this.delete_id.length = 0
      this.delete_id[0] = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this record ?',
        accept: this.acceptAlert
      })
      
    },
    openConfirmForCertificate (id, type) {
      if (type === 'single') {
        this.selected_cer_deleteing_id[0] = id
      }
      this.deleted_cer_id.length = 0
      this.deleted_cer_id[0] = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this record ?',
        accept: this.acceptAlertCertificate
      })
      
    },
    acceptAlertCertificate () { 
      this.deletingcertificategenerated('single')
    },
    acceptAlert () { 
      this.deletingcertificate('single')
    },
    acceptAlertShare () { 
      this.deletingSharecertificate('single')
    },
    async deletingcertificategenerated (type) {
      const customer_id = this.$store.getters.customerId
      let payload = []
      try {
        if (type === 'bulk') {
          const ids = this.selectedGenCertificate.map(ele => {
            return ele.certificate_id
          })
         
          payload = {
            certificate_ids:ids
          }

        } else {
          payload = {
            certificate_ids:this.deleted_cer_id
          }
        }
        await deleteCerificateApi(payload, customer_id)
        this.fetchgeneratedCertificate()
        this.$vs.notify({
          title: 'Success',
          text: 'Certificate deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.selectedGenCertificate.length = 0

      } catch (error) {}
    },
    async deletingcertificate (type) {
      const customer_id = this.$store.getters.customerId
      let payload = []
      try {
        if (type === 'bulk') {
           
          const ids = this.selectedCertificateTemplate.map(ele => {
            return ele.certificate_template_id
          })
          console.log(ids)
          payload = {
            certificate_template_ids:ids
          }

        } else {
          payload = {
            certificate_template_ids:this.delete_id
          }
        }
        await deleteTemplateCerificateApi(payload, customer_id)

        if (this.certificate_template.length === 0 && !this.meta.next_page_url) {
          this.fetchtemplateCertificate(this.meta.current_page - 1)
        } else {
          this.fetchtemplateCertificate(this.meta.current_page)
        }

        this.$vs.notify({
          title: 'Success',
          text: 'Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.selectedCertificateTemplate.length = 0

      } catch (error) {}
    },
    async deletingSharecertificate (type) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const staff_id =userInfo.id
      let payload = []
      try {
        if (type === 'bulk') {
           
          const ids = this.selectedSharedCertificate.map(ele => {
            return ele.certificate_id
          })
          payload = {
            certificate_ids:ids
          }

        } else {
          payload = {
            certificate_ids:this.delete_share_id
          }
        }
        await deleteShareCerificateApi(payload, staff_id)
        this.fetchShared()
        this.$vs.notify({
          title: 'Success',
          text: 'Deleted Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.selectedCertificateTemplate.length = 0

      } catch (error) {}
    },
    bulkDelete () { 
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete all selected records ?',
        accept: this.bulkAlertDelete
      })
  
      
    },
    bulkDeleteShare () { 
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete all selected records ?',
        accept: this.bulkAlertDeleteShare
      })
  
      
    },
    bulkDeleteGenerateCer () { 
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete all selected records ?',
        accept: this.bulkAlertCertificateDelete
      })
  
      
    },
    bulkAlertCertificateDelete () {
      this.deletingcertificategenerated('bulk')

    },
    bulkAlertDelete () {
      this.deletingcertificate('bulk')

    },
    bulkAlertDeleteShare () {
      this.deletingSharecertificate('bulk')

    }
   
  }
}